module.exports = __webpack_public_path__ + "img/AI-SPEAK-01-m.05c4c805.png";